import { Link } from "react-router-dom";

interface Props {
  kicker?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionTitle({ kicker, title, desc, moreTo, moreLabel }: Props) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        {kicker && (
          <p className="mb-1 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            {kicker}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="btn-ghost hidden shrink-0 px-3 py-2 text-sm sm:inline-flex"
        >
          {moreLabel ?? "查看全部"}
          <i className="ri-arrow-right-line text-sm" />
        </Link>
      )}
    </div>
  );
}